import { PayloadAction } from '../../../store.model';
import { ActionType } from '../transcript-dialog.action';
import { TranscriptDialogState } from '../transcript-dialog.state';

import { SetNoteViaSummary } from './set-note-via-summary.action';

export function setNoteViaSummaryReducer(
    state: TranscriptDialogState,
    action: PayloadAction<
        ActionType.COACHING_DETAIL__TD__SET_NOTE_VIA_SUMMARY,
        SetNoteViaSummary
    >,
): TranscriptDialogState {
    try {
        return {
            ...state,
            didAddCommitmentNoteViaSummary: action.payload.commitment,
            didAddObservationNoteViaSummary: action.payload.observation,
        };
    } catch (err) {
        console.log(err);
        return state;
    }
}
